import QuestionItem from './detail'
import QuestionSetter from './setter'
import listComponent from '@/util/proto/listComponent'
import LicenseSelect from '../../license/partial/license-select'

const displayLicense = (d) => {
  return (d.licenses || []).map(i => i.name).join(';')
}

export default {
  extends: listComponent,
  data() {
    return {
      columns: [
        /*{
          type: 'selection',
          width: 60,
          align: 'center'
        },*/
        {
          title: '题目类型',
          key: 'examTypeText',
          width:120
        },
        {
          title: '题目大纲',
          key: 'categoryName',
          width:160
        },
        {
          title: '题目',
          key: 'title',
          minWidth:350
        },
        {
          title:'适用证照',
          key:'displayLicense',
          minWidth:200,
        },
        {
          title: '操作',
          key: 'action',
          width: 120,
          align: 'center',
          render: (h, params) => {
            const node = [
              <a v-permission="exam.qa.update" on-click={()=>this.edit(params.row)}>编辑</a>,
              <a v-permission="exam.qa.delete" on-click={()=>this.remove(params.row)}>删除</a>
            ]
            return this.$utils.link(node,<Divider type="vertical" />)
          }
        }
      ],
      data: [],
      params: {
        categoryId: null,
        examType: null,
        title: null,
        licenseId:null,
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
    }
  },
  computed: {
    removeDisable() {
      return this.selection.length == 0
    },
    examCategories(){
      return this.$request.examCategories().then(resp => {
        return Promise.resolve(resp.data.map( i => ({ value:i.id , label:i.title })))
      })
    }
  },
  created() {
    this.def = { ...this.params }
    this.search()
  },

  methods: {

    search() {
      let params = { search: { ...this.params }, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
      // this.$request.ciEnterprises(params).then(resp => {
      this.$request.examQuestions(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.conv(resp.data.list || [] , {'examType':'$questionType' , displayLicense })
          this.page.total = resp.data.total || 0
        }
      })
    },

    edit(row) {
      this.$refs['item'].init(row.id)
    },

    create() {
      this.$refs['item'].init()
    },

    remove(row) {
      this.$ui.confirm(this.$request.examQuestionDelete, `确定删除 ${row.title} ？`)(row.id).then(resp => {
        if (!resp.code) {
          this.$Message.success('操作成功')
          this.selection = []
          this.search()
        }
      })
    },

    view(row){

    },

    handleAddToTpl(){
      let params = this.selection
      this.$refs['itemSetter'].add( params )
      /*
      this.$ui.confirm(this.$request.mock ,  '确定添加？')(params).then( resp => {
        if(!resp.code){
          this.$Message.success('操作成功')
          this.selection = []
          this.list()
        }
      })
      */
    },

    reset() {
      this.$utils.fill(this.params, this.def)
      this.search()
    },


    handleUpdate() {
      this.search()
    },

    handleChange(pageNum, pageSize) {
      if (this.page.pageNum != pageNum || this.page.pageSize != pageSize) {
        this.page.pageNum = pageNum
        this.page.pageSize = pageSize
        this.search()
      }
    },

    handleSelect(selection){
      this.selection = selection.map(i=>i.id)
    }
  },
  render(){
    return <sl-page>
        <div class="page-filter">
          <sl-search on-search={this.search} on-reset={this.reset}>
            <sl-search-item label="">
              <sl-select dict={this.examCategories} v-model={this.params.categoryId} placeholder="题目大纲" />
            </sl-search-item>
            <sl-search-item label="">
              <sl-select v-model={this.params.examType} placeholder="题目类型" dict="$questionType" />
            </sl-search-item>
            <sl-search-item label="">
              <i-input v-model={this.params.title} placeholder="题目" />
            </sl-search-item>
            <sl-search-item label="">
              <LicenseSelect multiple={false} v-model={this.params.licenseId} />
            </sl-search-item>
            <template slot="action">
              <Button v-permission="exam.qa.insert" type="primary" icon="md-add" on-click={this.create}>新增</Button>
            </template>
          </sl-search>
        </div>
        <div class="pg-bd">
          <sl-table showHeader={true} loading={this.loading} page={this.page} columns={this.columns} data={this.data} on-change={this.$tableChange}>
          </sl-table>
        </div>
        <QuestionItem ref="item" on-update={this.handleUpdate} />
        <QuestionSetter ref="itemSetter" on-update={this.handleUpdate} />
      </sl-page>
  }
}